module.exports = __webpack_public_path__ + "static/media/gotoRewardHistory.a92839b9.svg";